var exports = {
  "widget-container": "xa15a2ab7--232cc8--widget-container",
  "container": "xa15a2ab7--232cc8--container",
  "without-margins": "xa15a2ab7--232cc8--without-margins",
  "popup-container": "xa15a2ab7--232cc8--popup-container",
  "icon": "xa15a2ab7--232cc8--icon",
  "popup-container--left": "xa15a2ab7--232cc8--popup-container--left",
  "popup-container--right": "xa15a2ab7--232cc8--popup-container--right",
  "popup-container--center": "xa15a2ab7--232cc8--popup-container--center",
  "popup": "xa15a2ab7--232cc8--popup",
  "popup-content": "xa15a2ab7--232cc8--popup-content",
};

module.exports = exports;
